<template>
  <div id="app">
    <head-Back title="加载中"></head-Back>
    <div class="loading-div">
      <img class="loading" src="../../assets/img/timg.gif" />
      <p>页面加载中…</p>
    </div>
  </div>
</template>
<script>
import headBack from "../common/head-back-app";
import { mapGetters } from "vuex";
//接口地址
import api from "../../api/index";
//toast组件
import tips from "@/estoast";
import util from "@/utils/util";
import store from "@/store";
import * as types from "../../store/types";

export default {
  name: "app",
  data() {
    return {
      msg: "正在加载",
      flag: true,
      url: "",
      mjb: "",
      params: ""
    };
  },
  mounted() {
    this.$point.init(new Date());
    console.log("加载完成");
    // this.getSecond();
  },
  methods: {
    //发送验证码
    getSecond() {
      let _this = this;
      var userInfo = this.getUserInfo;
      this.url = util.getParams("path");
      this.mjb = util.getParams("mjb");
      if (this.mjb != null && this.mjb != undefined && this.mjb != "") {
        store.commit(types.SET_MJB, this.mjb);
      }
      let url = window.location.href;
      console.log(" 页面加载地址跳转：" + url);

      var paydues = util.getParams("paydues");
      console.log(" 续费标识：" + paydues);
      if (paydues == 1) {
        localStorage.setItem("paydues_" + userInfo.id, "1");
      }

      var pid = util.getParams("pid");
      var cid = util.getParams("cid");
      if (cid != null && cid != undefined && cid != "") {
        store.commit(types.SET_CHANNEL, cid);
      }
      if (pid != null && pid != undefined && pid != "") {
        store.commit(types.SET_PID, pid);
      }

      console.log("地址的跳转" + decodeURIComponent(this.url));

      if (this.url != "") {
        console.log(JSON.stringify(this.url));

        // window.location.href = "this.url";
      } else {
        setTimeout(function() {
          _this.getSecond();
        }, 200);
      }
    },
    buildPamras(url, param) {
      var urls = url.split("?");
      alert(JSON.stringify(urls));

      if (urls.length > 1) {
        //参数评级
        url = url + "&content=" + param;
      } else {
        url = url + "?content=" + param;
      }
      return url;
    }
  },
  beforeCreate() {
    var token = util.getParams("token");

    console.log("页面加载开始 token:" + token);

    var ua = navigator.userAgent;
    console.log("页面加载开始 ua:" + JSON.stringify(ua));
    if (ua.indexOf("(qml)") > 0) {
      console.log("页面加载开始 ua flag:" + true);

      store.commit(types.SET_APP_FLAG, true);
    }

    if (token == null || token == undefined) {
      //关闭浏览器
      window.location.href = "hqml://closeWindow";
    }
    store.commit(types.LOGIN, token);
    localStorage.setItem("token", token);

    this.$axiosHttp({
      method: "POST",
      url: api.qml.getPopData,
      data: { flag: 1 }
    })
      .then(res => {
        if (res.code == 0) {
          console.log("url地址" + res);
          var params = res.result;
          var url = util.getParams("path");

          url = this.buildPamras(url, params);
          alert(JSON.stringify(url));

          console.log("url地址" + url);
          url = decodeURIComponent(url);
          alert(JSON.stringify(url));

          window.location.href = url;
        } else {
          tips.toast(res.message);
        }
      })
      .catch(err => {
        tips.toast(err);
        console.log(err);
      });
  },
  computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList",
      "getSToken"
    ])
  },
  components: {
    headBack
  }
};
</script>
<style  scoped>
.loading-div {
  width: 750px;
  height: auto;
  margin: 220px auto 20px;
}
.loading {
  width: 112px;
  height: 112px;
}
.loading-div p {
  font-size: 36px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/popLoad.vue